import request from '@/utils/request'
import { createKeyedSingleFlight } from '@/utils/singleFlight'
import { getAccessToken } from '@/utils/accessToken'

const requestImageAgentList = createKeyedSingleFlight(() => request({
  url: '/api/agent/get-image-agent-list',
  method: 'GET'
}), () => getAccessToken() || '')

/**
 * 获取智能体列表
 */
export function getClientAgentList(data) {
  return request({
    url: '/api/agent/get-client-agent-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取dashboard智能体列表
 */
export function getDashboardAgentList() {
  return request({
    url: '/api/agent/get-dashboard-agent-list',
    method: 'GET'
  })
}

/**
 * 获取游客可见的首页推荐智能体列表。
 * 公开接口只返回首页展示和入口判断所需字段。
 */
export function getPublicDashboardAgentList() {
  return request({
    url: '/api/agent/get-public-dashboard-agent-list',
    method: 'GET'
  })
}

/**
 * 获取网页生成聚合入口智能体列表
 */
export function getWebGenerationEntryAgentList() {
  return request({
    url: '/api/agent/get-web-generation-entry-agent-list',
    method: 'GET'
  })
}

/**
 * 获取图片生成聚合入口智能体列表
 */
export function getImageGenerationEntryAgentList() {
  return request({
    url: '/api/agent/get-image-generation-entry-agent-list',
    method: 'GET'
  })
}

/**
 * 获取dashboard more智能体列表
 */
export function getDashboardMoreAgentList(data) {
  return request({
    url: '/api/agent/get-dashboard-more-agent-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取用户智能体列表
 */
export function getAgentPageList(data) {
  return request({
    url: '/api/agent/get-agent-page-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取用户智能体列表
 */
export function getMyAgentList(data) {
  return request({
    url: '/api/agent-user/get-my-agent-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取文本聊天智能体列表
 */
export function getTextAgentList(data) {
  return request({
    url: '/api/agent/get-text-agent-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取图片智能体列表
 */
export function getImageAgentList() {
  return requestImageAgentList()
}

/**
 * 获取游客可见的系统图片模型列表。
 * 该接口只返回公开展示字段和图片生成控件配置，不包含用户/团队模型。
 */
export function getPublicImageAgentList() {
  return request({
    url: '/api/agent/get-public-image-agent-list',
    method: 'GET'
  })
}

/**
 * 获取 @ 候选智能体列表
 */
export function getMentionAgentList(data) {
  return request({
    url: '/api/agent/get-mention-agent-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取所有智能体列表
 */
export function getALlAgentList(data) {
  return request({
    url: '/api/agent/get-all-agent-list',
    method: 'GET',
    params: data
  })
}

/**
 * 获取用户智能体分页列表
 */
export function getMyAgentPageList(data) {
  return request({
    url: '/api/agent-user/get-my-agent-page-list',
    method: 'GET',
    params: data
  })
}

/**
 * 新增用户智能体
 */
export function addAgentUserRe(data) {
  return request({
    url: '/api/agent-user/add-agent-user-re',
    method: 'POST',
    data
  })
}

/**
 * 更新/删除我的智能体
 */
export function updateAgentUserRe(data) {
  return request({
    url: '/api/agent-user/update-agent-user-re',
    method: 'POST',
    data
  })
}

/**
 * 新增自定义智能体
 */
export function addMyAgent(data) {
  return request({
    url: '/api/agent/add-my-agent',
    method: 'POST',
    data
  })
}

/**
 * 获取自定义智能体
 */
export function getMyAgentById(data) {
  return request({
    url: '/api/agent/get-my-agent-by-id',
    method: 'GET',
    params: data
  })
}

/**
 * 更新自定义智能体
 */
export function updateMyAgent(data) {
  return request({
    url: '/api/agent/update-my-agent',
    method: 'POST',
    data
  })
}

/**
 * 更新自定义智能体
 */
export function updateAgentBase(data) {
  return request({
    url: '/api/agent/update-agent-base',
    method: 'POST',
    data
  })
}

/**
 * 删除自定义智能体
 */
export function deleteMyAgent(data) {
  return request({
    url: '/api/agent/delete-my-agent',
    method: 'POST',
    data
  })
}

/**
 * 智能体标签列表
 * */
export function getAgentTagList(data) {
  return request({
    url: '/api/agent/get-tag-list',
    method: 'get',
    params: data
  })
}

/**
 * 获取用户侧创建智能体所需的安全模型选项
 */
export function getClientLLMOptions() {
  return request({
    url: '/api/agent/get-client-llm-options',
    method: 'get',
  })
}

/**
 * 获取系统智能体
 * */
export function getShowAgentInfo(data) {
  return request({
    url: '/api/agent/get-show-info',
    method: 'get',
    params: data
  })
}



/**
 * 获取ai编辑器组件配置
 * */
export function getAiToolConfig(data) {
  return request({
    url: '/api/agent/config/ai-tool',
    method: 'get',
    params: data
  })
}

/**
 * 获取ai相关配置
 * */
export function getAiConfig(data) {
  return request({
    url: '/api/agent/config/ai-config',
    method: 'get',
    params: data
  })
}

/**
 * 获取ai项目弹窗配置
 * */
export function getAiExtensionConfig(data) {
  return request({
    url: '/api/agent/config/ai-edit-extension',
    method: 'get',
    params: data
  })
}

/**
 * 获取智能体积分信息
 * */
export function agentPointsInfo(data) {
  return request({
    url: '/api/agent/agent-points-info',
    method: 'post',
    data
  })
}

/**
 * 获取智能体工具列表
 * */
export function getAgentTools(data) {
  return request({
    url: '/api/agent/tools',
    method: 'get',
    params: data
  })
}

/**
 * 绑定工具到智能体
 * */
export function bindAgentTools(data) {
  return request({
    url: '/api/agent/bind-tools',
    method: 'post',
    data
  })
}

/**
 * 获取智能体技能列表
 * */
export function getAgentSkills(data) {
  return request({
    url: '/api/agent/skills',
    method: 'get',
    params: data
  })
}

/**
 * 绑定技能到智能体
 * */
export function bindAgentSkills(data) {
  return request({
    url: '/api/agent/bind-skills',
    method: 'post',
    data
  })
}
